import { render } from "./MobileMenu.vue?vue&type=template&id=965afcf6&scoped=true"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"

import "./MobileMenu.vue?vue&type=style&index=0&id=965afcf6&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965afcf6"]])

export default __exports__